import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateMerchantCreatedCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type MerchantCreatedState = void;

export const MERCHANT_CREATED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<MerchantCreatedState>>,
): ConditionType<MerchantCreatedState, Condition.MerchantCreated> => ({
  name: "Merchant created",
  description() {
    return "Return was created by merchant";
  },
  Details(props: ConditionTypeDetailsProps<MerchantCreatedState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.MERCHANT_CREATED };
  },
  valid() {
    return validateMerchantCreatedCondition({}).valid;
  },
});
